module.exports = __webpack_public_path__ + "static/media/icn-campaigns-selected.a9c1de15.svg";